import { render, staticRenderFns } from "./AcountSettings.vue?vue&type=template&id=e4b78c60&"
import script from "./AcountSettings.vue?vue&type=script&lang=js&"
export * from "./AcountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports